import React, { useState, useEffect } from 'react';
import { SlTab, SlTabGroup, SlTabPanel } from '@shoelace-style/shoelace/dist/react';
import UnpickedAds from "./UnpickedAds";
import MyAds from "./MyAds/MyAds";
import AllAds from "./AllAds";
import PaymentCompletedAds from "./PaymentCompletedAds";
import InvoiceRequests from "./InvoiceRequests";
import DesignerPerformanceReport from "./DesignerPerformanceReport";
import { useTableState } from './utils/useTableState';
import { ChatProvider, useChatContext } from '../../context/ChatContext';
import ChatPanel from './components/ChatPanel';

const DesignerTabInner = () => {
    const [activeTab, setActiveTab] = useState('my-ads');
    const { closeExpandedRows, adCounts, fetchAdCounts } = useTableState();
    const { closeChat } = useChatContext();

    const handleTabChange = (event) => {
        closeExpandedRows();
        closeChat();
        const newTab = event.detail.name;
        setActiveTab(newTab);
    };

    useEffect(() => {
        fetchAdCounts();
        const intervalId = setInterval(fetchAdCounts, 5 * 1000);
        return () => clearInterval(intervalId);
    }, []);

    return (
        <div>
            <SlTabGroup onSlTabShow={handleTabChange}>
                <SlTab slot="nav" panel="my-ads">My Ads <span className="text-blue-800 mx-1 py-1 px-2 rounded-full">{adCounts.myads}</span></SlTab>
                <SlTab slot="nav" panel="unpicked-ads">Unpicked Ads <span className="text-blue-800 mx-1 py-1 px-2 rounded-full">{adCounts.unpicked}</span></SlTab>
                <SlTab slot="nav" panel="all-ads">All Ads <span className="text-blue-800 mx-1 py-1 px-2 rounded-full">{adCounts.total}</span></SlTab>
                <SlTab slot="nav" panel="payment-completed-ads">Payment Completed <span className="text-blue-800 mx-1 py-1 px-2 rounded-full">{adCounts.payment_completed}</span></SlTab>
                <SlTab slot="nav" panel="invoice-requests">Invoice Requests</SlTab>
                <SlTab slot="nav" panel="designer-performance">Designer Performance</SlTab>

                <SlTabPanel name="my-ads">
                    {activeTab === 'my-ads' && <MyAds key={activeTab} adCounts={adCounts} />}
                </SlTabPanel>
                <SlTabPanel name="unpicked-ads">
                    {activeTab === 'unpicked-ads' && <UnpickedAds key={activeTab} adCounts={adCounts} />}
                </SlTabPanel>
                <SlTabPanel name="all-ads">
                    {activeTab === 'all-ads' && <AllAds key={activeTab} />}
                </SlTabPanel>
                <SlTabPanel name="payment-completed-ads">
                    {activeTab === 'payment-completed-ads' && <PaymentCompletedAds key={activeTab} />}
                </SlTabPanel>
                <SlTabPanel name="invoice-requests">
                    {activeTab === 'invoice-requests' && <InvoiceRequests key={activeTab} isActive={activeTab === 'invoice-requests'} />}
                </SlTabPanel>
                <SlTabPanel name="designer-performance">
                    {activeTab === 'designer-performance' && <DesignerPerformanceReport key={activeTab} />}
                </SlTabPanel>
            </SlTabGroup>
            <ChatPanel />
        </div>
    );
};

const DesignerTab = () => (
    <ChatProvider>
        <DesignerTabInner />
    </ChatProvider>
);

export default DesignerTab;
